"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = SortOrderDown;

var _SortOrderDown = require("@adobe/react-spectrum-workflow/dist/SortOrderDown");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function SortOrderDown(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_SortOrderDown.A4uSortOrderDown, null));
}